export type {
  GlobalContextProps,
  LocalSettings,
} from "@/contexts/GlobalContext";
export {
  GlobalConsumer,
  default as GlobalContext,
  GlobalProvider,
} from "@/contexts/GlobalContext";
export type {
  OpinionContextProps,
  OpinionProviderProps,
  StoredOpinion,
} from "@/contexts/OpinionContext";
export {
  OpinionConsumer,
  default as OpinionContext,
  OpinionProvider,
} from "@/contexts/OpinionContext";
export type {
  PollContextProps,
  PollProviderProps,
} from "@/contexts/PollContext";
export {
  getPollOptionVotesPercent,
  getPollSympathizersCount,
  getPollTotalVotes,
  getPollVotesCount,
  PollConsumer,
  default as PollContext,
  PollProvider,
} from "@/contexts/PollContext";
export type {
  QuizContextProps,
  QuizProviderProps,
} from "@/contexts/QuizContext";
export {
  QuizConsumer,
  default as QuizContext,
  QuizProvider,
} from "@/contexts/QuizContext";
export type { VotingContextProps } from "@/contexts/VotingContext";
export {
  VotingConsumer,
  default as VotingContext,
  VotingProvider,
} from "@/contexts/VotingContext";
